"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var operator_exports = {};
__export(operator_exports, {
  _getOperator: () => _getOperator,
  assertUpdateShape: () => assertUpdateShape,
  isOperator: () => isOperator
});
module.exports = __toCommonJS(operator_exports);
var import_platform = __toESM(require("@hcengineering/platform"));
var import_analytics = require("@hcengineering/analytics");
function $push(document, keyval) {
  const doc = document;
  for (const key in keyval) {
    if (doc[key] === void 0) {
      doc[key] = [];
    }
    const kvk = keyval[key];
    if (typeof kvk === "object" && kvk != null) {
      const arr = doc[key];
      const desc = kvk;
      if ("$each" in desc) {
        if (arr != null && Array.isArray(arr)) {
          arr.splice(desc.$position ?? 0, 0, ...desc.$each);
        }
      } else {
        arr.push(kvk);
      }
    } else if (doc[key] === null || doc[key] === void 0) {
      doc[key] = [kvk];
    } else if (Array.isArray(doc[key])) {
      doc[key].push(kvk);
    } else {
      import_analytics.Analytics.handleError(new Error(`invalid array value: ${JSON.stringify(doc[key])} `));
      doc[key] = [kvk];
    }
  }
}
__name($push, "$push");
function $pull(document, keyval) {
  const doc = document;
  for (const key in keyval) {
    if (doc[key] === void 0) {
      doc[key] = [];
    }
    if (!Array.isArray(doc[key])) {
      import_analytics.Analytics.handleError(new Error(`$pull operation on non-array field: ${key}, value: ${JSON.stringify(doc[key])}`));
      doc[key] = [];
      continue;
    }
    const arr = doc[key];
    const kvk = keyval[key];
    if (typeof kvk === "object" && kvk !== null) {
      const { $in } = kvk;
      doc[key] = (arr ?? []).filter((val) => {
        if ($in !== void 0) {
          return !$in.includes(val);
        } else {
          for (const [kk, kv] of Object.entries(kvk)) {
            if (val[kk] !== kv) {
              return true;
            }
          }
          return false;
        }
      });
    } else {
      doc[key] = (arr ?? []).filter((val) => val !== kvk);
    }
  }
}
__name($pull, "$pull");
function matchArrayElement(docs, query) {
  let result = [...docs];
  for (const key in query) {
    const value = query[key];
    const tresult = [];
    for (const object of result) {
      const val = object[key];
      if (val === value) {
        tresult.push(object);
      }
    }
    result = tresult;
    if (tresult.length === 0) {
      break;
    }
  }
  return result;
}
__name(matchArrayElement, "matchArrayElement");
function $update(document, keyval) {
  const doc = document;
  for (const key in keyval) {
    if (doc[key] === void 0) {
      doc[key] = [];
    }
    if (!Array.isArray(doc[key])) {
      import_analytics.Analytics.handleError(
        new Error(`$update operation on non-array field: ${key}, value: ${JSON.stringify(doc[key])}`)
      );
      doc[key] = [];
      continue;
    }
    const val = keyval[key];
    if (typeof val === "object") {
      const arr = doc[key];
      const desc = val;
      for (const m of matchArrayElement(arr, desc.$query)) {
        for (const [k, v] of Object.entries(desc.$update)) {
          m[k] = v;
        }
      }
    }
  }
}
__name($update, "$update");
function $inc(document, keyval) {
  const doc = document;
  for (const key in keyval) {
    const cur = doc[key] ?? 0;
    if (typeof cur !== "number" || isNaN(cur)) {
      import_analytics.Analytics.handleError(
        new Error(`$inc operation on non-numeric field: ${key}, value: ${JSON.stringify(doc[key])}`)
      );
      doc[key] = keyval[key];
      continue;
    }
    const increment = keyval[key];
    if (typeof increment !== "number" || isNaN(increment)) {
      import_analytics.Analytics.handleError(
        new Error(`$inc operation with invalid increment: ${key}, increment: ${JSON.stringify(increment)}`)
      );
      continue;
    }
    doc[key] = cur + increment;
  }
}
__name($inc, "$inc");
function $unset(document, keyval) {
  const doc = document;
  for (const key in keyval) {
    if (doc[key] !== void 0) {
      delete doc[key];
    }
  }
}
__name($unset, "$unset");
function $rename(document, keyval) {
  const doc = document;
  for (const key in keyval) {
    if (doc[key] !== void 0) {
      doc[keyval[key]] = doc[key];
      delete doc[key];
    }
  }
}
__name($rename, "$rename");
const operators = {
  $push,
  $pull,
  $update,
  $inc,
  $unset,
  $rename
};
function isOperator(o) {
  if (o === null || typeof o !== "object") {
    return false;
  }
  const keys = Object.keys(o);
  return keys.length > 0 && keys.every((key) => key.startsWith("$"));
}
__name(isOperator, "isOperator");
const UPDATE_OPERATORS = /* @__PURE__ */ new Set(["$push", "$pull", "$update", "$inc", "$unset"]);
const UNSAFE_UPDATE_KEYS = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
const MAX_UPDATE_DEPTH = 1e3;
function assertUpdateShape(ops) {
  const invalid = /* @__PURE__ */ __name(() => {
    throw new import_platform.PlatformError(new import_platform.Status(import_platform.Severity.ERROR, import_platform.default.status.BadRequest, {}));
  }, "invalid");
  if (ops === null || typeof ops !== "object" || Array.isArray(ops)) invalid();
  const keys = Object.keys(ops);
  const operatorKeys = keys.filter((key) => key.startsWith("$"));
  if (operatorKeys.length > 0 && operatorKeys.length !== keys.length) invalid();
  for (const key of operatorKeys) {
    if (!UPDATE_OPERATORS.has(key)) invalid();
    const payload = ops[key];
    if (payload === null || typeof payload !== "object" || Array.isArray(payload)) invalid();
    const fields = Object.keys(payload);
    if (fields.some((field) => field.startsWith("$"))) invalid();
    if (key === "$update" && (keys.length !== 1 || fields.length !== 1)) invalid();
  }
  const visited = /* @__PURE__ */ new Set();
  const pending = [{ value: ops, depth: 0 }];
  while (pending.length > 0) {
    const entry = pending.pop();
    if (entry === void 0) break;
    const { value, depth } = entry;
    if (value === null || typeof value !== "object" || visited.has(value)) continue;
    if (depth > MAX_UPDATE_DEPTH) invalid();
    visited.add(value);
    for (const [key, child] of Object.entries(value)) {
      if (key.split(".").some((part) => UNSAFE_UPDATE_KEYS.has(part))) invalid();
      if (child !== null && typeof child === "object") pending.push({ value: child, depth: depth + 1 });
    }
  }
}
__name(assertUpdateShape, "assertUpdateShape");
function _getOperator(name) {
  const operator = operators[name];
  if (operator === void 0) throw new Error(`unknown operator: ${name}`);
  return operator;
}
__name(_getOperator, "_getOperator");
//# sourceMappingURL=operator.js.map
